import { render, staticRenderFns } from "./FetchV2.vue?vue&type=template&id=0217787c&scoped=true&"
import script from "./FetchV2.vue?vue&type=script&lang=js&"
export * from "./FetchV2.vue?vue&type=script&lang=js&"
import style0 from "./FetchV2.vue?vue&type=style&index=0&id=0217787c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0217787c",
  null
  
)

export default component.exports